import { render, staticRenderFns } from "./DiagnosticDetailView.vue?vue&type=template&id=42392064&scoped=true&lang=pug"
import script from "./DiagnosticDetailView.vue?vue&type=script&lang=js"
export * from "./DiagnosticDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42392064",
  null
  
)

export default component.exports